import { ContractStatus, EscrowStatus, JobStatus, KYCStatus } from '../enums';

export const ACTIVE_JOB_STATUSES = [JobStatus.OPEN] as const;
export const TERMINAL_JOB_STATUSES = [JobStatus.CLOSED, JobStatus.FILLED, JobStatus.EXPIRED] as const;

export const ACTIVE_CONTRACT_STATUSES = [ContractStatus.ACTIVE, ContractStatus.PAUSED] as const;
export const TERMINAL_CONTRACT_STATUSES = [
  ContractStatus.COMPLETED,
  ContractStatus.CANCELLED,
] as const;

export const FUNDED_ESCROW_STATUSES = [
  EscrowStatus.FUNDED,
  EscrowStatus.PARTIALLY_RELEASED,
] as const;

export const KYC_VERIFIED_STATUSES = [KYCStatus.APPROVED] as const;
export const KYC_PENDING_STATUSES = [
  KYCStatus.PENDING,
  KYCStatus.SCHEDULED,
  KYCStatus.IN_REVIEW,
] as const;
